import React, { FunctionComponent } from 'react';

import CodeBlock from '../CodeBlock/CodeBlock';
import CodeBlockSingleLine from '../CodeBlockSingleLine/CodeBlockSingleLine';
import { WarningMessage } from '../WarningMessage/WarningMessage';
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';
import { useTranslation } from 'react-i18next';

type GivingCheckoutLinkProps = {
  id: string;
  link: string;
  type?: 'single' | 'multi';
};

const GivingCheckoutLink: FunctionComponent<GivingCheckoutLinkProps> = ({
  id,
  link,
  type = 'multi',
}) => {
  const { t } = useTranslation();
  const copyToClipboard = useCopyToClipboard();

  if (type === 'single')
    return (
      <>
        <p className="jg-font-weight-regular">{t('linkDetails.link.label')}</p>
        <CodeBlockSingleLine textContents={link} />
        <WarningMessage message={t('common.copyWarning')} />
      </>
    );

  return (
    <>
      <p className="jg-font-weight-regular">{t('linkDetails.link.label')}</p>
      <CodeBlock
        id={`giving-checkout-link-${id}`}
        ariaLabel={t('linkDetails.link.ariaLabel')}
        dataQa={`givingCheckoutLink-${id}`}
      >
        {link}
      </CodeBlock>
      <WarningMessage message={t('common.copyWarning')} />
      <button
        type="button"
        id="giving-checkout-link-copy-button"
        data-qa="giving-checkout-link-copy-button"
        className="jg-btn jg-btn--secondary setup__buttons__copy-link gc-button-width"
        onClick={() => {
          copyToClipboard(
            'giving-checkout-link-copy-button',
            'giving-checkout-link-multi',
          );
        }}
      >
        {t('common.copy')}
      </button>
    </>
  );
};

export default GivingCheckoutLink;
